import { useReduxState } from 'hooks';
import { Button } from 'components/common';
import { Icon } from 'components/common/icons';

import type { CommonBlockPropsReader } from 'components/reader/blocks';

interface Props extends Pick<CommonBlockPropsReader<'discussion'>, 'fontSize'> {
  count: number;
  onLessClick: () => void;
  onMoreClick: () => void;
  showLess: boolean;
}

const ReaderBlockDiscussionShowMore = ({
  count,
  fontSize,
  onLessClick,
  onMoreClick,
  showLess
}: Props) => {
  const { messages } = useReduxState();

  return (
    <div className="show-more">
      {count > 0 ? (
        <Button
          category="light"
          onClick={onMoreClick}
          size="small"
          style={{ margin: '0 5px' }}
          text={
            <span>
              {messages.commonShowMore}
              <Icon
                icon="chevron-down"
                style={{
                  fontSize: {
                    small: '1.1rem',
                    medium: '1.2rem',
                    large: '1.3rem',
                    huge: '1.5rem'
                  }[fontSize],
                  marginLeft: 5
                }}
              />
              <span className="count">{count}</span>
            </span>
          }
        />
      ) : null}

      {showLess ? (
        <Button
          category="light"
          onClick={onLessClick}
          size="small"
          style={{ margin: '0 5px' }}
          text={
            <span>
              {messages.commonShowLess}
              <Icon
                icon="chevron-up"
                style={{
                  fontSize: {
                    small: '1.1rem',
                    medium: '1.2rem',
                    large: '1.3rem',
                    huge: '1.5rem'
                  }[fontSize],
                  marginLeft: 5
                }}
              />
            </span>
          }
        />
      ) : null}

      <style jsx>{`
        .show-more {
          text-align: center;
          margin-top: 25px;
        }
        .count {
          background-color: white;
          border-radius: 20px;
          margin-left: 8px;
          margin-right: 2px;
          padding: 1px 6px;
        }
      `}</style>
    </div>
  );
};

export default ReaderBlockDiscussionShowMore;
